import React, {memo} from 'react'
import PropTypes from 'prop-types'

/* Components */
import HbImageView from '../../../../components/HbImage/view/HbImageView'
import HbPlaceholderFrame from '../../../../components/Placeholder/frame/HbPlaceholderFrame'

/* Styles */
import s from './product-card.scss'

const ProductImage = memo(({image, alt, badgeLabel, isBot, sponsoredCampaignWidget}) => (
  <div className={s.image} data-test-id='cc-image'>
    {badgeLabel?.badgeImageUrl && (
      <div className={s.yarinKapinda} aria-hidden='true'>
        <img src={badgeLabel?.url} alt={badgeLabel?.tagName}/>
      </div>
    )}
    <HbPlaceholderFrame ratio={104/132}>
      <HbImageView
        className={s.productImage}
        shouldLoadEagerly={isBot}
        image={{
          src: !sponsoredCampaignWidget ? image?.url : image,
          alt,
          size: !sponsoredCampaignWidget ? '104-132' : '300',
          componentSize: {width: '104', height: '132'},
          originSize: {width: image?.width ?? '', height: image?.height ?? ''},
        }}/>
    </HbPlaceholderFrame>
  </div>
))

ProductImage.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  }),
  alt: PropTypes.string,
  sponsoredCampaignWidget: PropTypes.bool
}

export default ProductImage
